import React from "react";
import { NavLink } from 'react-router-dom';
import styles from './style.module.css';


const FixedBottomMenu = props => {
  const { menu } = props;
  return (
    <ul className={styles.fixed_menu}>
      {menu.map(__menu_item => (
        <li>
          <NavLink to={__menu_item.link}>
            <span className={styles.ico}>
              {__menu_item.ico}
            </span>
          </NavLink>
        </li>
      ))}
    </ul>
  )
}

export default FixedBottomMenu;
